import { Pipe, PipeTransform } from '@angular/core';
import { BrandInfo } from '../../_models/reports/brand-info.model';
import { brandShortCode } from '../../_services/brand-filter.service';

/** `{{ row.companyId | brandShortCode: brands }}` — the brand short code for a Brand column. */
@Pipe({
  name: 'brandShortCode',
  standalone: false
})
export class BrandShortCodePipe implements PipeTransform {
  transform(companyId: number, brands: BrandInfo[]): string {
    return brandShortCode(companyId, brands);
  }
}
